export const en = {
    title: 'The business trip is executed',
    description: 'The trip is approved, and the added services are executed',
    trip_route: 'Trip route',
};
